import React from 'react';
import './list-display.scss';
import ListDisplay from './list-display';
import { observer } from 'mobx-react-lite';
import { SystemConfiguration } from '../../../utils/system-configuration';
import { CountryDto } from '../../../dtos/system-configuration.dto';
import CountryItem from '../firewall-policy/rule-editor/rule-content-zone/country-item';
import { PolicySummaryPanelData } from './policy-summary-utils';


const GeoFilteringContent: React.FC<{data: PolicySummaryPanelData}> = observer(({ data }) => {

    const { countryDtoMap } = SystemConfiguration.getInstance();

    const countryArr = Object.values(countryDtoMap).flat();
    const countryMap: { [key: string]: CountryDto } = countryArr.reduce((acc: { [key: string]: CountryDto }, country) => {
        acc[country.countryName] = country;
        return acc;
    }, {});

    return <ListDisplay lists={data.lists} ItemRenderer={({item}) => <CountryItem data={countryMap[item]}/>} />;
});

export default GeoFilteringContent;